

import AnimatedSection from '../components/AnimatedSection';

// --- Skills Section ---
const Skills = () => {
    const skills = {
        "Languages": ["Kotlin", "Java", "Scala", "JavaScript"],
        "Mobile": ["Android SDK", "Jetpack Compose", "Coroutines", "RxJava", "Dagger/Hilt"],
        "Architecture": ["Clean Architecture", "MVVM", "MVI", "Modularization"],
        "Tools & Platforms": ["Git", "CI/CD", "Firebase", "AWS", "Jira"],
    };
    return (
        <AnimatedSection id="skills" className="py-24">
            <h2 className="text-3xl font-bold text-white text-center mb-12">Technical Toolkit</h2>
            <div className="max-w-4xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8">
                {Object.entries(skills).map(([category, list]) => (
                    <div key={category}>
                        <h3 className="text-lg font-semibold text-cyan-400 mb-4">{category}</h3>
                        <ul className="space-y-2">
                            {list.map(skill => (
                                <li key={skill} className="text-slate-400">{skill}</li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </AnimatedSection>
    );
};
export default Skills;
